import React, { Component } from 'react';
import Modal, { ConfirmModal } from '../components/container/Modal';
import { fetchPut } from '../cruds/remote';
import List from '../cruds/List';
import DeletableRowList from '../components/container/DeletableRow';
import CollapsibleRowList from '../components/container/CollapsibleRow';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import { withRoles } from '../components/container/WithRole';

const filters = [
  { name: 'departmentSearch', placeholder: 'general.department' },
  { name: 'activitySearch', placeholder: 'general.activity' },
  {
    name: 'substanceSearch',
    placeholder: 'general.substance',
    type: 'exclusion',
    toggleName: 'withSubstances',
    toggleLabel: 'departmentSubstances.withSubstances',
  },
];

const ENTITY_NAME = 'departmentActivities';
const TITLE = 'departmentSubstances.title';

class DepartmentSubstancesList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  filtersValidation = (filters, name) => {
    const { withSubstances } = filters;
    if (withSubstances === false) {
      filters.substanceSearch = '';
    }
  };

  handleRemove = (departmentActivity, substance, updateCallback) => {
    const content = <span>
                      {getLabel(this.context.locale, 'general.deleteAssociation')}
                      <span style={{ fontWeight: 600 }}> {departmentActivity.departmentName}</span>
                      , <span style={{ fontWeight: 600 }}>{departmentActivity.activityName} </span>
                      {getLabel(this.context.locale, 'general.and')}
                      <span style={{ fontWeight: 600 }}> {substance.substanceCode}</span>?
                    </span>;

    this.setState({
      showModal: true,
      modalContent: content,
      modalSubmit: () => this.handleActualRemove(departmentActivity, substance, updateCallback),
    });
  };

  handleActualRemove = (departmentActivity, substance, updateCallback) => {
    const updatedActivities = departmentActivity.substances
                                        .filter(a => a.substanceId !== substance.substanceId)
                                        .map(a => String(a.substanceId));

    const url = [ENTITY_NAME, departmentActivity.id, 'substances'].join('/');

    fetchPut(url, { value: updatedActivities })
        .then(res => this.setState({
            showModal: false,
            modalContent: '',
            modalSubmit: null,
          }, updateCallback),
        ).catch(err => this.setState({
          showModal: false,
          modalContent: '',
          modalSubmit: null,
          showErrorModal: true,
          error: err.message,
        }));

  };

  closeModal = () => {
    this.setState({ showModal: false, error: '' });
  };

  closeErrorModal = () => {
    this.setState({ showErrorModal: false, error: '' });
  };

  render() {
    const table = <CollapsibleRowList
                      optionLabelName={['companyName', 'departmentName', 'activityName']}
                      hideViewButton={true}
                      hideEditButton={!withRoles(['A', 'B', 'C'])}
                  >
                    <DeletableRowList
                      name="substances"
                      labelProperty="substanceCode"
                      handleRemove={this.handleRemove}
                      emptyMessage="departmentSubstances.emptyResults"
                      showDeleteButton={withRoles(['A', 'B', 'C'])}
                    />
                  </CollapsibleRowList>;

    return (
      <div>
        <ConfirmModal
          isOpen={this.state.showModal}
          title="general.confirmDeletion.title"
          handleCloseModal={this.closeModal}
          submitAction={this.state.modalSubmit}
        >
          <div style={{ padding: 20 }}>{this.state.modalContent}</div>
        </ConfirmModal>
        <Modal
          isOpen={this.state.showErrorModal}
          title="general.errorOccurred"
          handleCloseModal={this.closeErrorModal}
        >
          <div style={{ padding: 20 }}>{this.state.error}</div>
        </Modal>
        <List
          title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={this.props.match.url}
          hideAddButton={true}
          component={table}
          filters={filters}
          filtersValidation={this.filtersValidation}
        />
      </div>
    );
  }

}

DepartmentSubstancesList.contextTypes = {
  locale: PropTypes.string,
};

export default DepartmentSubstancesList;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentSubstancesList.js